import { useTranslation } from "react-i18next";
import { Mail } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const EmployeeContactSection = ({ formData, updateField, phonePlaceholder = "+216 XX XXX XXX" }) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      <h3 className="font-medium flex items-center space-x-2">
        <Mail className="h-4 w-4" />
        <span>{t("employeesPage.sections.contact")}</span>
      </h3>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" placeholder={t("employeesPage.placeholders.email")} value={formData.email} onChange={(e) => updateField("email", e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="telephone">{t("employeesPage.labels.phone")}</Label>
          <Input id="telephone" placeholder={phonePlaceholder} value={formData.phone} onChange={(e) => updateField("phone", e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="adresse">{t("employeesPage.labels.address")}</Label>
          <Input id="adresse" placeholder={t("employeesPage.placeholders.address")} value={formData.address} onChange={(e) => updateField("address", e.target.value)} />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="ville">{t("employeesPage.labels.city")}</Label>
          <Input id="ville" placeholder={t("employeesPage.placeholders.city")} value={formData.city} onChange={(e) => updateField("city", e.target.value)} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="code_postal">{t("employeesPage.labels.postalCode")}</Label>
          <Input id="code_postal" placeholder={t("employeesPage.placeholders.postalCode")} value={formData.postal_code} onChange={(e) => updateField("postal_code", e.target.value)} />
        </div>
        <div />
      </div>
    </div>
  );
};

export default EmployeeContactSection;
